/**
 * Set up routing for all Transition views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import transition views
import CreateTransition from './views/CreateTransition.js.jsx';
import TransitionList from './views/TransitionList.js.jsx';
import SingleTransition from './views/SingleTransition.js.jsx';
import UpdateTransition from './views/UpdateTransition.js.jsx';

class TransitionRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute login={true} exact path="/transitions" component={TransitionList} />
        <YTRoute login={true} exact path="/transitions/new" component={CreateTransition} />
        <YTRoute login={true} exact path="/transitions/:transitionId" component={SingleTransition}/>
        <YTRoute login={true} exact path="/transitions/:transitionId/update" component={UpdateTransition}/>
      </Switch>
    )
  }
}

export default TransitionRouter;



// WEBPACK FOOTER //
// modules/transition/TransitionRouter.js.jsx